import { isValidNumber } from 'libphonenumber-js';
import { FormControl, FormHelperText } from 'material-ui/Form';
import { InputLabel } from 'material-ui/Input';
import PropTypes from 'prop-types';
import React from 'react';
import Phone from 'react-phone-number-input';
import 'react-phone-number-input/rrui.css';
import 'react-phone-number-input/style.css';
import 'entoro-shared/src/styles/react-phone-number-input.css';

const validatePhone = (value) => {
  if (!value) {
    return undefined;
  }

  return isValidNumber(value) ? undefined : 'Invalid phone number';
};

const inputStyles = {
  color: 'rgba(0, 0, 0, 0.87)',
  display: 'inline-flex',
  position: 'relative',
  fontSize: '16px',
  alignItems: 'baseline',
  fontFamily: 'Heebo, sans-serif',
  marginTop: '16px',
};

const PhoneNumberInput = ({
  input: { value, onBlur, onChange },
  label,
  meta: { touched, error },
  ...custom
}) => (
  <FormControl fullWidth error={Boolean(touched && error)}>
    <InputLabel shrink {...custom}>
      {label}
    </InputLabel>
    <Phone
      country='US'
      flagComponent={({ countryCode }) => <span>{countryCode}</span>}
      autoComplete='false'
      style={inputStyles}
      selectStyle={{ height: '32px' }}
      inputStyle={{ height: '32px' }}
      className='phone-input-field'
      placeholder='Enter phone number'
      value={value}
      onChange={(val) => {
        onBlur();
        onChange(val);
      }}
    />
    {touched && error ? <FormHelperText>{error}</FormHelperText> : null}
  </FormControl>
);

PhoneNumberInput.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.node,
  meta: PropTypes.object.isRequired,
};

PhoneNumberInput.defaultProps = {
  label: null,
};

export { PhoneNumberInput, validatePhone };



// WEBPACK FOOTER //
// ./src/components/FormFields/PhoneNumberInput.js